// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning_warning__3HDqP","play":"warning_play__WodlF","appear":"warning_appear__3Sne-"};